<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
  >
    <template slot="header">
      <div class="d-flex justify-space-between w100">
        <span>{{ title }}</span>
        <v-btn
          color="success"
          outlined
          @click="generateExcel()"
        >
          Export to Excel
        </v-btn>
      </div>
    </template>
    <template slot="body">
      <v-row align="center">
        <v-col
          v-for="tab, idx in tabs"
          :key="idx"
          cols="auto"
          :style="`cursor: pointer; border-bottom: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '2px solid #1976d2' : 'none'};`"
          class="ml-2 mr-2 pt-6"
          @click="tabChange(tab)"
        >
          <span :style="`font-size: 16px !important; color: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '#1976d2' : isDarkMode ? '' : 'rgba(0,0,0,0.8)'}; font-weight: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? 'bold' : 'normal'};`">{{ tab.name }}</span>
        </v-col>
        <v-spacer />
        <v-col
          cols="2"
          class="pt-2 pb-4"
        >
          <v-autocomplete
            v-model="filterProjectId"
            :items="projects"
            item-text="name"
            item-value="id"
            hide-details
            label="Project"
            clearable
          />
        </v-col>
        <v-col
          cols="2"
          class="pt-2 pb-4"
        >
          <v-text-field
            v-model="search"
            hide-details
            label="Search"
          />
        </v-col>
      </v-row>
      <v-row v-if="groupedData">
        <v-col>
          <v-card
            elevation="0"
            outlined
            style="height: calc(100vh - 290px);
              position: relative;
              overflow: auto;"
          >
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
            />
            <table
              style="border-collapse: collapse; width: 100%;"
            >
              <tbody>
                <tr
                  v-if="!loading && groupedData.length === 0"
                >
                  <td
                    class="no-data-td py-4"
                  >
                    No data available
                  </td>
                </tr>
                <tr
                  v-for="(group, index) in groupedData"
                  :key="index"
                  style="display: flex; flex-direction: column;"
                >
                  <td
                    style="width: 100%; background-color: #E9F5E9; display: flex; align-items: center; gap: 6px;"
                    class="pa-3"
                  >
                    <!-- <v-icon
                      style="font-size: 30px; font-weight: bold; color: #000"
                      @click="closeLocation(group)"
                    >
                      {{ closedLocations.includes(group.name) ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
                    </v-icon> -->
                    <span style="font-size: 26px; font-weight: bold">{{ group.name }}</span>
                  </td>
                  <td v-if="!closedLocations.includes(group.name)">
                    <table style="border-collapse: collapse; width: 100%;">
                      <tbody>
                        <tr
                          v-for="(projectGroup, projectIndex) in group.elements"
                          :key="projectIndex"
                          style="display: flex; flex-direction: column;"
                        >
                          <td
                            class="pt-3 pb-1 pr-3 pl-12"
                            style="width: 100%; background-color: #F5F5F5; padding: 12px; display: flex; align-items: center; gap: 6px;"
                          >
                            <v-icon
                              style="font-size: 22px; font-weight: bold; color: #000"
                              @click="closeProject(projectGroup)"
                            >
                              {{ closedProjects.includes(projectGroup.name) ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
                            </v-icon>
                            <span style="font-size: 18px; font-weight: bold">{{ projectGroup.name }}</span>
                          </td>
                          <td v-if="!closedProjects.includes(projectGroup.name)">
                            <table style="border-collapse: collapse; width: 100%;">
                              <thead style="width: 100%; background-color: #F5F5F5;">
                                <tr>
                                  <th
                                    style="padding-left: 75px;"
                                    class="finished-goods-th">
                                    Tag Id
                                  </th>
                                  <th class="finished-goods-th-small">
                                    Tag Number
                                  </th>
                                  <th class="finished-goods-th-small">
                                    Work Order
                                  </th>
                                  <th class="finished-goods-th-big">
                                    Reference
                                  </th>
                                  <th class="finished-goods-th-small">
                                    Cut Width
                                  </th>
                                  <th class="finished-goods-th-small">
                                    Cut Height
                                  </th>
                                  <th class="finished-goods-th-small">
                                    Sqft
                                  </th>
                                  <th class="finished-goods-th">
                                    Location
                                  </th>
                                  <th v-if="!isQuarantinedMode" class="finished-goods-th">
                                    Shelf
                                  </th>
                                  <th
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-th"
                                  >
                                    Quarantine Reason
                                  </th>
                                  <th
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-th"
                                  >
                                    Quarantine Sub Reason
                                  </th>
                                  <th
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-th"
                                    style="text-align: center;"
                                  >
                                    Days Quarantined
                                  </th>
                                  <th class="finished-goods-note-th">
                                    Note
                                  </th>
                                  <th
                                    class="finished-goods-th"
                                    style="text-align: center;"
                                  >
                                    Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(finishedGood, finishedGoodIndex) in projectGroup.projectElements"
                                  :key="finishedGoodIndex"
                                  style="border-bottom: 1px solid #E0E0E0;"
                                >
                                  <td
                                    style="padding-left: 75px"
                                    class="finished-goods-td">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.tag_id }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-small">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.tag_number }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-small">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.work_order }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-big">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.floor_number }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-small">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.cut_width }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-small">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.cut_height }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td-small">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.sqft }}
                                    </text-highlight>
                                  </td>
                                  <td class="finished-goods-td">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.location_name }}
                                    </text-highlight>
                                  </td>
                                  <td v-if="!isQuarantinedMode" class="finished-goods-td">
                                    <text-highlight
                                      :queries="search === null ? '' : search"
                                    >
                                      {{ finishedGood.inventory_location_name }}
                                    </text-highlight>
                                  </td>
                                  <td
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-td"
                                  >
                                    {{ finishedGood.quarantine_reason ? finishedGood.quarantine_reason.name : '' }}
                                  </td>
                                  <td
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-td"
                                  >
                                    {{ finishedGood.quarantine_sub_reason ? finishedGood.quarantine_sub_reason.name : '' }}
                                  </td>
                                  <td
                                    v-if="isQuarantinedMode"
                                    class="finished-goods-td"
                                    style="text-align: center;"
                                  >
                                    {{ finishedGood.quarantined_days || finishedGood.quarantined_days === 0 ? finishedGood.quarantined_days : '' }}
                                  </td>
                                  <td class="finished-goods-note-td">
                                    <span
                                      v-if="finishedGood.notes && finishedGood.notes.length > 0"
                                      class="finished-goods-note"
                                    >
                                      <v-btn
                                        class="finished-goods-note-btn"
                                        icon
                                        small
                                        @click="openNoteForm(finishedGood.id)"
                                      >
                                        <v-icon
                                          small
                                        >
                                          mdi-eye
                                        </v-icon>
                                      </v-btn>
                                      <span class="finished-goods-note-text">{{ finishedGood.notes && finishedGood.notes.length > 0 ? finishedGood.notes[0].text : '' }}</span>
                                    </span>
                                    <v-btn
                                      v-else
                                      color="primary"
                                      small
                                      icon
                                      @click="openNoteForm(finishedGood.id)"
                                    >
                                      <v-icon small>
                                        mdi-pencil
                                      </v-icon>
                                    </v-btn>
                                  </td>
                                  <td class="finished-goods-td" style="text-align: center;">
                                    <v-chip
                                      v-if="finishedGood && finishedGood.status"
                                      small
                                      :color="finishedGood.status.color ? finishedGood.status.color : '#000000'"
                                      text-color="white"
                                    >
                                      {{ finishedGood.status.name }}
                                    </v-chip>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
          <div
            style="display: flex; border: 1px solid #E0E0E0; gap: 12px;"
            class="justify-end align-center pa-5"
          >
            <span style="font-size: 16px;">
              Rows per page:
              {{ total === 0 ? 0 : (pagination.page - 1) * pagination.itemsPerPage + 1 }}
              -
              {{ Math.min(pagination.page * pagination.itemsPerPage, total) }}
              of {{ total }}
            </span>
            <div>
              <v-icon
                class="pagination-icon"
                :class="{ 'pagination-icon-disabled': !hasPreviousPage }"
                :disabled="!hasPreviousPage"
                @click="previousPage()"
              >
                mdi-chevron-left
              </v-icon>
              <v-icon
                class="pagination-icon"
                :class="{ 'pagination-icon-disabled': !hasNextPage }"
                :disabled="!hasNextPage"
                @click="nextPage()"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </div>
        </v-col>
      </v-row>
      <NoteForm
        v-show="false"
        ref="noteForm"
        :simple="true"
        :add-only="true"
        @success="init()"
      />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// eslint-disable-next-line import/no-extraneous-dependencies
import { debounce } from 'lodash';
import NoteForm from '@/components/forms/notes/NoteForm.vue';
import * as XLSX from 'xlsx';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
    NoteForm,
  },
  props: {

  },
  data: () => ({
    groupedData: [],
    locations: [],
    tabs: [],
    projects: [],
    pagination: {
      itemsPerPage: 500,
      page: 1,
    },
    total: 0,
    loading: false,
    selectedTab: null,
    filterJobSubClass: null,
    filterLocationId: null,
    filterProjectId: null,
    filterStatusId: null,
    search: null,
    closedLocations: [],
    closedProjects: [],
    noteTypeIdFinishedGood: 3,
    title: 'Finished Goods',
    finishedGoodStatusIdQuarantined: 13,
  }),
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([

    ]),
    isQuarantinedMode() {
      return this.filterStatusId === this.finishedGoodStatusIdQuarantined;
    },
    hasNextPage() {
      return !this.loading && this.total > this.pagination.page * this.pagination.itemsPerPage;
    },
    hasPreviousPage() {
      return !this.loading && this.pagination.page > 1;
    },
  },
  watch: {
    filterProjectId() {
      this.init();
    },
    search: debounce(function () {
      this.init();
    }, 500),
  },
  created() {
  },
  methods: {

    async init() {
      this.groupedData = [];
      this.total = 0;
      this.pagination.page = 1;
      this.closedProjects = [];
      this.closedLocations = [];
      this.get();
    },

    async get() {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          job_sub_class_id: this.filterJobSubClass,
          location_id: this.filterLocationId,
          project_id: this.filterProjectId,
          status_id: this.filterStatusId,
        },
        pagination: this.pagination,
        search: this.search,
      };
      const res = await this.$api.finishedGood.read(submitModel, null, 'read-finished-goods');
      console.log(res);
      this.loading = false;
      if (!res || !res.grouped) {
        this.total = 0;
        return;
      }
      // res.grouped.forEach((element) => {
      //   const locationIndex = this.groupedData.findIndex((x) => x.name === element.name);
      //   if (locationIndex === -1) {
      //     this.groupedData.push(element);
      //   } else {
      //     element.elements.forEach((projectElement) => {
      //       const projectIndex = this.groupedData[locationIndex].elements.findIndex((x) => x.name === projectElement.name);
      //       if (projectIndex === -1) {
      //         this.groupedData[locationIndex].elements.push(projectElement);
      //       } else {
      //         projectElement.projectElements.forEach((finishedGood) => {
      //           this.groupedData[locationIndex].elements[projectIndex].projectElements.push(finishedGood);
      //         });
      //       }
      //     });
      //   }
      // });
      this.groupedData = res.grouped;
      this.total = res.total || 0;
    },

    async getLocations() {
      this.tabs = [];
      this.locations = await this.$api.location.getList();

      const locationId14Precidio = 3;
      const locationId300Chrislea  = 8;
      const locationIdOld300Chrislea = 2;
      this.tabs.push(...this.locations.filter((x) => x.id === locationId14Precidio || x.id === locationId300Chrislea || x.id === locationIdOld300Chrislea));
      this.tabs.forEach((x) => {
        // eslint-disable-next-line no-param-reassign
        x.type = 'location';
      });
      this.tabs.push({
        id: 2, name: 'CORNER POST', color: '#E53935', type: 'sub-class',
      }, {
        id: 3, name: 'EURO DOOR', color: '#FDD835', type: 'sub-class',
      });
    },

    async getProjects() {
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };

      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (!res || !res.data) {
        this.projects = [];
        return;
      }
      this.projects = res.data;
    },

    // handleScroll(event) {
    //   if (this.loading) return;
    //   const container = event.target;
    //   const scrollPosition = container.scrollTop + container.clientHeight;
    //   const scrollThreshold = container.scrollHeight - 50; // Trigger 50px before the bottom

    //   if (scrollPosition >= scrollThreshold) {
    //     this.pagination.page += 1;
    //     this.get();
    //   }
    // },

    nextPage() {
      if (!this.hasNextPage) return;
      this.pagination.page += 1;
      this.get();
    },

    previousPage() {
      if (!this.hasPreviousPage) return;
      this.pagination.page -= 1;
      this.get();
    },

    async open(options = {}) {
      this.title = options.title || 'Finished Goods';
      this.filterStatusId = options.statusId || null;
      this.selectedTab = null;
      await this.getLocations();
      if (this.tabs.length > 0) {
        this.selectedTab = this.tabs[0];
        this.applyTabFilters(this.selectedTab);
      }
      this.init();
      this.getProjects();
      this.$refs.dialogBox.open();
    },

    openNoteForm(itemId) {
      this.$refs.noteForm.open(itemId, this.noteTypeIdFinishedGood);
    },

    applyTabFilters(item) {
      if (item.type === 'sub-class') {
        this.filterJobSubClass = item.id;
        this.filterLocationId = null;
      } else if (item.type === 'location') {
        this.filterLocationId = item.id;
        this.filterJobSubClass = null;
      }
    },

    tabChange(item) {
      if (this.selectedTab === item) return;
      this.selectedTab = item;
      this.applyTabFilters(item);
      this.init();
    },

    closeLocation(group) {
      if (this.closedLocations.includes(group.name)) {
        this.closedLocations = this.closedLocations.filter((x) => x !== group.name);
      } else {
        this.closedLocations.push(group.name);
      }
    },

    closeProject(projectGroup) {
      if (this.closedProjects.includes(projectGroup.name)) {
        this.closedProjects = this.closedProjects.filter((x) => x !== projectGroup.name);
      } else {
        this.closedProjects.push(projectGroup.name);
      }
    },

    async generateExcel() {
      this.$bus.$emit('loading');
      this.items = [];
      const submitModel = {
        filters: {
          job_sub_class_id: this.filterJobSubClass,
          location_id: this.filterLocationId,
          project_id: this.filterProjectId,
          status_id: this.filterStatusId,
        },
      };
      const res = await this.$api.finishedGood.read(submitModel, null, 'read-finished-goods');
      if (!res || !res.grouped) {
        this.$bus.$emit('loading');
        return;
      }

      this.exportToExcel(res.grouped);

      this.$bus.$emit('loading');
    },

    exportToExcel(grouped) {
      const headers = [
        'Tag Id',
        'Tag Number',
        'Work Order',
        'Reference',
        'Cut Width',
        'Cut Height',
        'Sqft',
        'Production Location',
        'Location',
        'Shelf',
        'Status',
        'Note',
      ];

      if (this.isQuarantinedMode) {
        headers.splice(9, 1); // Remove Shelf
        headers.splice(9, 0, 'Quarantine Reason', 'Quarantine Sub Reason', 'Days Quarantined');
      }

      const rows = [];

      grouped.forEach((group) => {
        group.elements.forEach((el) => {
          let serial = 1;
          el.projectElements.forEach((item) => {
            let row = {
              // eslint-disable-next-line no-plusplus
              'Tag Id': item.tag_id || '',
              'Tag Number': item.tag_number || '',
              'Work Order': item.work_order || '',
              'Reference': item.floor_number || '',
              'Cut Width': item.cut_width || '',
              'Cut Height': item.cut_height || '',
              'Sqft': item.sqft || '',
              'Production Location': group.name || '',
              'Location': item.location_name || '',
              'Status': item.status.name || '',
              'Note': item.notes && item.notes.length > 0 ? item.notes[0].text : '',
            };

            if (this.isQuarantinedMode) {
              row['Quarantine Reason'] = item.quarantine_reason ? item.quarantine_reason.name : '';
              row['Quarantine Sub Reason'] = item.quarantine_sub_reason ? item.quarantine_sub_reason.name : '';
              row['Days Quarantined'] = item.quarantined_days || item.quarantined_days === 0 ? item.quarantined_days : '';
            } else {
              row['Shelf'] = item.inventory_location_name || '';
            }
            rows.push(row);
          });
        });
      });

      const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Finished Goods');

      const now = FormatHelpers.getFileTimestamp();

      let fileNamePrefix = 'finished_goods';
      if (this.isQuarantinedMode) fileNamePrefix = 'quarantined_windows';

      XLSX.writeFile(workbook, `${fileNamePrefix}_${now}.xlsx`);
    },
  },
};
</script>

<style scoped>

.finished-goods-th{
  text-align: left;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.finished-goods-th-small{
  text-align: left;
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.finished-goods-th-big{
  text-align: left;
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.finished-goods-td{
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.finished-goods-td-small{
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.finished-goods-td-big{
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}

.finished-goods-note-th,
.finished-goods-note-td{
  text-align: left;
  width: 260px;
  min-width: 260px;
  max-width: 260px;
}

.finished-goods-note{
  display: flex;
  align-items: center;
  width: 260px;
  min-width: 0;
  color: rgb(255, 152, 0);
}

.finished-goods-note-btn{
  flex: 0 0 auto;
}

.finished-goods-note-text{
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-data-td{
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
  font-size: 16px;
  vertical-align: middle;
}

.pagination-icon{
  font-size: 40px;
  cursor: pointer;
}

.pagination-icon-disabled{
  cursor: default;
  opacity: 0.35;
  pointer-events: none;
}
</style>
